'use client'

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

export default function HomeTestimonialSection() {
    return (
        <section className=" theme-pt-40 theme-pb-40 theme-pl-30 theme-pr-30">
            <div className="auto-container">
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 theme-mb-30">
                        <div className="site-heading text-left">
                            <h2>DEPOIMENTOS</h2>
                            <p>A confiança de quem já fez negócio conosco</p>
                        </div>
                    </div>
                </div>
                <div className="clearfix"></div>
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mr-auto ml-auto">
                        <Swiper
                            id='testimonial'
                            modules={[Autoplay]}
                            autoplay={{
                                delay: 5000,
                                disableOnInteraction: false,
                            }}
                            speed={900}
                            spaceBetween={30}
                            loop={true}
                        >
                            <div className='swiper-wrapper'>
                                <SwiperSlide className='testimonial-item'>
                                    <div className="tcontent">
                                        <blockquote>
                                            <p>Excelente atendimento. Ótimos profissionais.</p>
                                            <div className="testimonial-author">
                                                <p><strong className="font-weight-extra-bold">Reginaldo Zamplonio</strong></p>
                                            </div>
                                        </blockquote>
                                        <div className="testimonial-arrow-down"></div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide className='testimonial-item'>
                                    <div className="tcontent">
                                        <blockquote>
                                            <p>Lugar de altíssima confiança !</p>
                                            <div className="testimonial-author">
                                                <p><strong className="font-weight-extra-bold">Luci Gameiro</strong></p>
                                            </div>
                                        </blockquote>
                                        <div className="testimonial-arrow-down"></div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide className='testimonial-item'>
                                    <div className="tcontent">
                                        <blockquote>
                                            <p>Excelente atendimento. Conseguimos boas taxas. Só a agradecer!</p>
                                            <div className="testimonial-author">
                                                <p><strong className="font-weight-extra-bold">Gustavo C. Bueno</strong></p>
                                            </div>
                                        </blockquote>
                                        <div className="testimonial-arrow-down"></div>
                                    </div>
                                </SwiperSlide>
                            </div>
                        </Swiper>
                    </div>
                </div>
            </div>
        </section>
    );
}